<template>
	<div style="width: 100%; height: 85vh; overflow-y: auto" v-if="org.confirmed">
		<div class="info-header" style="display: flex">
			<el-image v-loading="image_src == undefined" :src="image_src" style="" />
			<div style="width: 45%" class="title">
				<h2>{{ org.name.String }}</h2>
			</div>
			<div v-if="tab < 2" style="justify-content: flex-end; align-items: center; display: flex; flex: 1">
				<el-button type="success" :disabled="error.length > 0" @click="handleSave">
					{{ $t("save") }}
				</el-button>

				<el-tooltip placement="bottom">
					<div slot="content">{{ $t("cancel") }}</div>
					<el-button @click="handleClear" circle size="small">
						<md-icon>clear</md-icon>
					</el-button>
				</el-tooltip>
			</div>
		</div>

		<div class="container-tab">
			<div :class="{ 'tab-effect': tab != 0 }" class="tab" @click="tab = 0">
				<span :class="{ 'tab-selected': tab == 0 }">{{ $t("bio-informations") }}</span>
			</div>
			<div :class="{ 'tab-effect': tab != 1 }" class="tab" @click="tab = 1">
				<span :class="{ 'tab-selected': tab == 1 }">{{ $t("other-informations") }}</span>
			</div>
			<div :class="{ 'tab-effect': tab != 2 }" class="tab" @click="tab = 2">
				<span :class="{ 'tab-selected': tab == 2 }">{{ $t("users") }}</span>
			</div>
			<div :class="{ 'tab-effect': tab != 3 }" class="tab" @click="tab = 3">
				<span :class="{ 'tab-selected': tab == 3 }">{{ $t("subscriptions") }}</span>
			</div>
		</div>

		<div style="width: 100%">
			<div v-if="tab < 2">
				<div v-if="tab === 0">
					<div>
						<school-main-form
							v-if="tab === 0"
							:element="org"
							:error="error"
							:clear="edit == undefined ? undefined : !edit"
							@edit="value => (edit = value)"
						/>
					</div>
				</div>
				<div v-if="tab === 1">
					<div>
						<school-secondary-form
							v-if="tab === 1"
							:element="org"
							:error="error"
							:clear="edit == undefined ? undefined : !edit"
							@edit="value => (edit = value)"
						/>
					</div>
				</div>
			</div>

			<div v-if="tab === 2">
				<school-users-table />
			</div>

			<div v-if="tab === 3">
				<organization-subscriptions
					:school="org"
					:clear="edit == undefined ? undefined : !edit"
					@edit="edit = true"
				/>
			</div>
		</div>
	</div>

	<div v-else>
		<div style="text-align: center">
			<h1>{{ $t("we-are-almost-there") + "..." }}</h1>
			<h3>{{ $t("confirm-school-email") }}</h3>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import SchoolUsersTable from "../form-component/school-users-table.vue"
import SchoolMainForm from "../form-component/school-main-form.vue"
import SchoolSecondaryForm from "../form-component/school-secondary-form.vue"
import AddButton from "../../_common/button/add-button.vue"
import OrganizationSubscriptions from "@/modules/organization/form-component/organization-subscriptions.vue"

export default {
	components: { SchoolMainForm, SchoolUsersTable, SchoolSecondaryForm, AddButton, OrganizationSubscriptions },
	name: "organization-home",
	data() {
		return {
			height: window.innerHeight - 285,
			focus: undefined,
			tab: 0,
			error: [],
			edit: undefined
		}
	},
	computed: {
		...mapGetters({
			org: "user/organization",
			image_src: "user/organizationLogo",
			updated: "organization/updated",
			add_subscription: "organization/add_subscription"
		})
	},
	watch: {
		updated: function (val) {
			if (val == "save-successful") this.$notification("success", this.$t("save-successful"), "", 4500)
			else if (val == "save-error") this.$notification("error", this.$t("save-error"), "", 0)
		}
	},
	methods: {
		...mapActions({
			saveCustomField: "organization/saveCustomField",
			doUser: "user/doUser",
			doImage: "user/doImage"
		}),
		handleClear: function () {
			this.edit = false
			this.error = []
		},

		handleSave() {
			this.saveCustomField({ id: this.org.id, tab: this.tab })
		}
	},
	created() {
		this.doImage()
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-tab.scss";
@import "src/assets/scss/my-form";

.info-header {
	display: flex;
	margin: 10px;

	.el-image {
		width: 150px;
		height: 150px;
	}

	input {
		font-size: 32px;
		padding: 20px;
	}
}

.data-item {
	display: flex;
	width: 100%;
	margin: 7px;

	.label {
		width: 25%;
		margin-top: auto;
		margin-bottom: auto;

		strong {
			float: right;
		}

		margin-right: 10px;
	}

	.value {
		margin-left: 10px;
		width: 75%;
	}

	.container {
		margin-left: 10px;
		display: flex;

		span {
			width: 15%;
			margin-top: auto;
			margin-bottom: auto;
			padding: 7px;
		}

		input {
			width: 75%;
		}
	}
}

.error {
	border: 1px solid red;
}
</style>
